import dayjs from 'dayjs';
import 'dayjs/locale/ro';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import isNil from 'lodash/isNil';
import tz from 'dayjs/plugin/timezone';
import { Locale } from '../enums/locale';
import { getTimezoneByLocale } from '../mappers/localeMap';
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(tz);
export const getYearsBetweenStartAndCurrentYear = (startYear) => {
    if (isNil(startYear) || startYear < 0)
        return [];
    const currentYear = dayjs().year();
    return Array.from(Array(currentYear + 1).keys()).slice(startYear);
};
export const renderDate = (date, locale = Locale.RO, defaultValue = '') => {
    if (!date || !dayjs(date).isValid())
        return defaultValue;
    return dayjs(date).locale(locale).format('L');
};
export const renderDateWithLocalTime = (date, locale = Locale.RO) => {
    if (!date || !dayjs(date).isValid())
        return '';
    const timezone = getTimezoneByLocale(locale);
    return dayjs.utc(date).tz(timezone).locale(locale).format('L, HH:mm');
};
export default dayjs;
